import { MedicalTypeEnum } from '@api/GoodocAPI';

const doctorTitle = new Map([
  [MedicalTypeEnum.Medicine, '의사'],
  [MedicalTypeEnum.KoreanMedicine, '한의사'],
  [MedicalTypeEnum.DentalMedicine, '치과의사']
]);

export const makeDoctorTitle = (type: MedicalTypeEnum | undefined) => {
  return doctorTitle.get(type ?? MedicalTypeEnum.Medicine);
};
